import 'stencil-apollo';
import { Component, Prop, h } from '@stencil/core';
import state from '@ugc-store';

import { createApolloClient } from '@ugc-utils/create-apollo-client';

@Component({
  tag: 'ugc-apollo',
  styleUrl: 'ugc-apollo.scss',
  shadow: false,
})
export class UgcApollo {
  @Prop({ mutable: true }) query: any = {};
  @Prop() storeName: any = '';

  render() {
    const setQuery = JSON.stringify(this.query) !== '{}';
    const client = createApolloClient();

    return setQuery ? (
      <apollo-provider client={client}>
        <apollo-query
          query={this.query}
          renderer={({ data, loading }) => {
            if (!loading) {
              state[this.storeName] = data;
              return <slot />;
            }
          }}
        />
      </apollo-provider>
    ) : (
      <slot />
    );
  }
}
